export const measurementsNavLinks = [
  { id: 1, title: "wszystkie pomiary", path: "/dashboard/measurements" },
  { id: 2, title: "nowy pomiar", path: "/dashboard/measurements/new" },
];
